module.exports = __webpack_public_path__ + "img/name_contact.2e85da59.png";